<script>
    import { Action } from '../'

    import { week } from '../../stores'

    export let title
    export let index
    export let disabled = false
    
    $:{
        if (!disabled && $week.items[index]?.length === 2){
            week.update((state) => ({
                ...state,
                currentDay: state.currentDay + 1
            }))
        }
    }
</script>

<div class="day-wrapper" class:disabled>
    <div class="title" class:disabled>{title}</div>

    <div class="drop-area day-drop {!disabled ? 'day-drop-active' : ''}">
        {#if $week.items[index]}
            {#each $week.items[index] as item}
                <div class="action-wrapper">
                    <Action data={item} {disabled} dayMode={true} />
                </div>
            {/each}
        {/if}
    </div>
</div>

<style lang="scss" module>
    .day-wrapper {
        display: flex;
        flex-direction: column;
        width: calc((100% - (4 * 20px) - (2 * 41px)) / 5);

        .title {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 92px;
            border-radius: 8px;
            background: rgb(246,115,54);
            background: linear-gradient(174deg, rgba(246,115,54,1) 0%, rgba(247,143,78,1) 48%, rgba(247,146,69,1) 100%);
            font-size: 24px;
            line-height: 30px;
            color: #ffffff;

            &.disabled {
                background: #D1D1D1;
            }
        }

        .drop-area {
            margin-top: 20px;
            border: 1px solid #F0F0F0;
            box-shadow: 6px 4px 70px rgba(183, 183, 183, 0.1);
            border-radius: 8px;
            height: 100%;
            padding-top: 20px;

            .action-wrapper {
                margin: 0 11px;
                margin-bottom: 17px;

                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }
    }

    @media (max-width: 1120px) {
        .day-wrapper {
            .title {
                font-size: 18px;
                line-height: 28px;
                height: 55px;
            }

            .drop-area {
                padding-top: 10px;
            }
        }
    }

    @media (max-width: 940px) {
        .day-wrapper {
            width: calc((100% / 5) - 18px);
        }
    }

    @media (max-width: 780px) {
        .day-wrapper {
            width: calc((100% / 5) - 5px);

            .drop-area {
                padding-top: 5px;

                .action-wrapper {
                    margin: 0 5px;
                    margin-bottom: 5px;
                }
            }
        }
    }

    @media (max-width: 720px) {
        .day-wrapper {
            width: 100%;

            &.disabled {
                display: none;
            }

            .title {
                font-size: 16px;
                line-height: 20px;
                height: 54px;
            }

            .drop-area {
                display: flex;
                justify-content: space-between;
                margin-top: 14px;
                height: 93px;
                padding: 10px;

                .action-wrapper {
                    margin: 0;
                    width: calc((100% / 2) - 5px);
                }
            }
        }
    }
</style>